import { CATEGORIES } from "@/setup.const";
import moment from "moment";

export const getCatName = (id) => CATEGORIES.find((e) => e.id === id)?.name;
export const getCatColor = (id) => CATEGORIES.find((e) => e.id === id)?.color;

export const convertAllCategoriesToBigCat = (event) => {
  // return corresponding big cat

  const getBigCategerories = (catId) => {
    if (catId === 27) {
      return 23;
    }
    if (catId === 26 || catId === 30 || catId === 32) {
      return 24;
    } else {
      return catId;
    }
  };

  return event.map((el) => ({
    ...el,
    categoryID: getBigCategerories(el.categoryID),
  }));
};

function set00h00AllElementAndSetStrCat(event) {
  const convertMoment = (event) =>
    moment(new Date(event.date))
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toString();

  return {
    ...event,
    date: convertMoment(event),
  };
}

function sortByDateElement(eventArray) {
  const sortedByDate = {};

  function pushOrCreateArray(event) {
    const eventDate = event.date;

    if (!sortedByDate[eventDate]) {
      sortedByDate[eventDate] = {
        events: [],
        date: eventDate,
      };
    }

    sortedByDate[eventDate]["events"].push(event);
  }

  eventArray.forEach(pushOrCreateArray);

  return Object.values(sortedByDate);
}

function getAddressAndDate(dataProps = []) {
  //
  function findUniqAddress(events = []) {
    return events.reduce((acc, item) => {
      const { addressId } = item;
      if (!acc.includes(addressId)) acc.push(addressId);
      return acc;
    }, []);
  }


  const out = [];
  for (const el of dataProps) {
    const { events, date } = el;
    const addressMap = events.reduce((acc, e) => (acc[e.addressId] = e.address) && acc, {})

    out.push({
      img: {
        addressMap,
        address: findUniqAddress(events),
        date: moment(new Date(date)).format("YYYY-MM-DD"),
      },
    });
  }

  return out;
}

function sortByCategories(eventArray) {
  function getFilterCat(events) {
    const filteredCat = {};

    CATEGORIES.forEach(
      (cat) =>
        (filteredCat[cat.id] = events.filter((e) => e.categoryID === cat.id))
    );
    return filteredCat;
  }

  return eventArray.map((el) => {
    return {
      events: getFilterCat(el.events),
      date: new Date(el.date),
    };
  });
}

export {
  set00h00AllElementAndSetStrCat,
  sortByDateElement,
  sortByCategories,
  getAddressAndDate,
};
